export enum APIServiceEnum {
  KNM_SERVICE = 'KNM_SERVICE',
  BASE_SERVICE = 'BASE_SERVICE',
  INDEX_SERVICE = 'INDEX_SERVICE',
  LK_SERVICE = 'LK_SERVICE',
  DEFAULT_SERVICE = 'DEFAULT_SERVICE',
  ANALYTIC_SERVICE = 'ANALYTIC_SERVICE',
  NOTIFICATION_SERVICE = 'NOTIFICATION_SERVICE',
}
